
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { GuardTour, GuardTourType } from "@/store/guard-tours/types";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";

const GuardTours = namespace("GuardTours");

@Component({})
export default class AssessmentTourFilter extends Vue {
    @GuardTours.Mutation setFilterTourTypeId: (guardTourTypeId: number) => void;
    @GuardTours.State filterTourTypeId: number;

    @Getter("getFeaturesList") featuresList: FeaturesList;

    @Emit("filter-tour-type")
    public filterTourTypeChanged() {}

    private guardTourType = GuardTourType;

    private get isAssessmentTourEnabled(): boolean {
		return get(this.featuresList, ["Mobile", "AssessmentTours"], false);
	}

    public filterGuardTour() {
        this.setFilterTourTypeId(GuardTourType.Guard);
        this.filterTourTypeChanged();
    }

    public filterAssessmentTour() {
        this.setFilterTourTypeId(GuardTourType.Assessment);
        this.filterTourTypeChanged();
    }
}
